/** Copies plain text to the clipboard. Returns whether the operation likely succeeded. */
export async function copyToClipboard(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text)
    } else {
      const hiddenInput = document.createElement('textarea')
      hiddenInput.value = text
      hiddenInput.setAttribute('readonly', '')
      hiddenInput.style.position = 'absolute'
      hiddenInput.style.left = '-9999px'
      document.body.appendChild(hiddenInput)
      hiddenInput.select()
      document.execCommand('copy')
      hiddenInput.remove()
    }

    return true
  } catch {
    return false
  }
}
